/* asvendo elektro — redesign interactions. Defensive, no deps. */
(function(){
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Scroll reveal ---- */
  function initReveal(){
    var els = document.querySelectorAll('.asv2-reveal:not(.is-in)');
    if(!els.length) return;
    if(reduce || !('IntersectionObserver' in window)){
      els.forEach(function(e){ e.classList.add('is-in'); }); return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    els.forEach(function(e){ io.observe(e); });
  }

  /* Der zweite Scroll-Zuhoerer fuer die Kopfzeile lag hier (ab 12 px). Entfallen
     am 06.08.2026 zusammen mit dem Effekt selbst — siehe asv-custom.css. */

  /* ---- Sticky add-to-cart (PDP) ---- */
  function initStickyAtc(){
    var bar = document.querySelector('.asv2-stickyatc');
    var anchor = document.querySelector('[data-asv2-buybox]');
    if(!bar || !anchor) return;
    var form = document.querySelector('product-form form[action*="/cart/add"], form[action*="/cart/add"]');
    var btn = bar.querySelector('[data-asv2-atc-btn]');
    if(btn && form){
      btn.addEventListener('click', function(e){
        e.preventDefault();
        var realBtn = form.querySelector('[type="submit"], button[name="add"]');
        if(realBtn){ realBtn.click(); }
        else { form.requestSubmit ? form.requestSubmit() : form.submit(); }
      });
    }
    if(!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        // show sticky once the main buy box has scrolled out of view (upward)
        var below = en.boundingClientRect.top < 0;
        bar.classList.toggle('is-on', !en.isIntersecting && below);
      });
    }, { threshold: 0 });
    io.observe(anchor);
  }

  // Fortschrittsbalken unter den Wisch-Schienen der Produktreihen.
  // Er wird erst hier eingeschaltet (.is-an) — ein Balken, den niemand
  // bewegen kann, waere eine Falschaussage. Angezeigt wird er nur dort, wo
  // wirklich mehr Inhalt als Platz da ist, und nur solange die Schiene
  // waagerecht rollt (unter 600 px, siehe asv-redesign.css).
  function initRail(){
    document.querySelectorAll('.asv2-rail').forEach(function(rail){
      var spur = rail.querySelector('.asv2-pgrid');
      var balken = rail.querySelector('.asv2-rail__bar');
      if(!spur || !balken) return;
      var daumen = balken.firstElementChild;
      if(!daumen) return;

      function zeichnen(ueber){
        var anteil = spur.clientWidth / spur.scrollWidth;      // sichtbarer Anteil
        var pos = ueber > 0 ? spur.scrollLeft / ueber : 0;     // 0 bis 1
        var breite = Math.max(anteil, 0.12);
        daumen.style.width = (breite * 100) + '%';
        // Der Daumen darf nur bis zum rechten Rand laufen, nicht darueber
        // hinaus: die volle Spur minus seiner eigenen Breite, in Prozent
        // SEINER Breite gerechnet, weil translateX sich darauf bezieht.
        daumen.style.transform = 'translateX(' + (pos * (100 / breite - 100)) + '%)';
      }
      function messen(){
        var ueber = spur.scrollWidth - spur.clientWidth;
        if(ueber <= 4){ balken.classList.remove('is-an'); return; }
        balken.classList.add('is-an');
        zeichnen(ueber);
      }

      spur.addEventListener('scroll', function(){
        var ueber = spur.scrollWidth - spur.clientWidth;
        if(ueber > 0) zeichnen(ueber);
      }, { passive: true });

      if('ResizeObserver' in window){ new ResizeObserver(messen).observe(spur); }
      else { window.addEventListener('resize', messen); }
      messen();
    });
  }

  // Der lange Platzhalter aus dem Entwurf passt erst ab Tablet ins Suchfeld.
  // Auf dem Handy steht der kurze schon im Markup, damit auch ohne JavaScript
  // ein vollstaendiger Satz zu lesen ist statt eines abgeschnittenen.
  function initSuchfeld(){
    var feld = document.querySelector('.asv-search__input[data-breit]');
    if(!feld || !window.matchMedia) return;
    var breit = window.matchMedia('(min-width: 700px)');
    var kurz = feld.getAttribute('placeholder');
    function setzen(){ feld.setAttribute('placeholder', breit.matches ? feld.dataset.breit : kurz); }
    setzen();
    if(breit.addEventListener) breit.addEventListener('change', setzen);
    else if(breit.addListener) breit.addListener(setzen);   // Safari vor 14
  }

  // Das Konto-Menue oeffnet und schliesst als <details> ohne Skript. Was ohne
  // Skript fehlt, ist nur die Bequemlichkeit: nebenan tippen oder Escape
  // druecken schliesst es. Deshalb steht das hier und nicht die Oeffnung
  // selbst — faellt die Datei aus, bleibt das Menue benutzbar.
  function initKontoMenue(){
    var box = document.querySelector('details.asv-konto__box');
    if(!box) return;
    document.addEventListener('click', function(e){
      if(box.open && !box.contains(e.target)) box.open = false;
    });
    document.addEventListener('keydown', function(e){
      if(e.key !== 'Escape' || !box.open) return;
      box.open = false;
      var knopf = box.querySelector('summary');
      if(knopf) knopf.focus();
    });
  }

  /* ---- Gewaehlten Variantenwert in Sicht rollen ----
     Unter 700 px stehen die Variantenwerte in einer waagerechten Schiene
     (asv-handy.css, Abschnitt 6). Kommt jemand ueber ?variant=… oder einen
     Serienlink herein, liegt der aktive Wert unter Umstaenden rechts
     ausserhalb — dann sieht die Seite aus, als sei nichts gewaehlt.
     Gerechnet wird ueber getBoundingClientRect statt offsetLeft: offsetLeft
     zaehlt zum naechsten positionierten Vorfahren, und das ist die Schiene
     nicht zwangslaeufig. */
  function schienenAusrichten(sofort){
    if(!window.matchMedia || !window.matchMedia('(max-width: 699px)').matches) return;
    document.querySelectorAll('.variant-picker__option-values').forEach(function(schiene){
      if(schiene.scrollWidth <= schiene.clientWidth + 4) return;
      var gewaehlt = schiene.querySelector('input:checked');
      var ziel = gewaehlt && (gewaehlt.closest('label') || gewaehlt.parentElement);
      if(!ziel) return;
      var z = ziel.getBoundingClientRect();
      var s = schiene.getBoundingClientRect();
      var abstand = (z.left + z.width / 2) - (s.left + s.width / 2);
      if(Math.abs(abstand) < 2) return;
      schiene.scrollBy({ left: abstand, behavior: (sofort || reduce) ? 'auto' : 'smooth' });
    });
  }

  /* ---- Inhaltsverzeichnis der Rechtsseiten ----
     Baut die Gliederung aus den <h2> des Dokuments. Warum aus JavaScript und
     nicht aus Liquid: der Rechtstext liegt als HTML im Seiteninhalt und wird
     dort gepflegt. Eine zweite, von Hand gefuehrte Gliederung waere nach der
     ersten Textaenderung falsch — und bei Pflichtangaben ist "falsch" teuer.
     Faellt JavaScript aus, bleibt das <nav> versteckt und der Text steht
     vollstaendig da. Die Pflichtangabe haengt an keiner Bedingung. */
  function rechtsverzeichnis(){
    var nav = document.querySelector('[data-rechtsverzeichnis]');
    if(!nav) return;
    var doku = document.querySelector('.asv-rt__doku');
    var liste = nav.querySelector('.asv-rt__navliste');
    if(!doku || !liste) return;
    var hs = doku.querySelectorAll('h2');
    if(hs.length < 3) return;   /* Unter drei Abschnitten ist ein Verzeichnis Zierrat. */

    var eintraege = [];
    Array.prototype.forEach.call(hs, function(h, i){
      if(!h.id){
        var basis = (h.textContent || '').toLowerCase()
          .replace(/[\u00e4]/g,'ae').replace(/[\u00f6]/g,'oe').replace(/[\u00fc]/g,'ue').replace(/[\u00df]/g,'ss')
          .replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'').slice(0,60);
        h.id = 'a-' + (basis || 'abschnitt') + '-' + i;
      }
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.className = 'asv-rt__navlink';
      a.textContent = h.textContent;
      li.appendChild(a); liste.appendChild(li);
      eintraege.push({ h: h, a: a });
    });
    nav.hidden = false;

    /* Wer mit /pages/datenschutz#auftragsverarbeiter ankommt, springt ins Leere:
       der Browser sucht die ID, bevor es sie gibt, und versucht es kein zweites
       Mal. Nach dem Setzen deshalb selbst nachziehen. */
    try{
      var ziel = location.hash ? document.getElementById(decodeURIComponent(location.hash.slice(1))) : null;
      if(ziel) ziel.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }catch(e){}

    /* Aktuellen Abschnitt markieren. rootMargin schneidet oben 20 % und unten
       70 % weg: markiert wird damit der Abschnitt im oberen Drittel des Bildes,
       nicht der, der gerade erst hereinragt. */
    if(!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        var t = eintraege.filter(function(e){ return e.h === en.target; })[0];
        if(!t) return;
        if(en.isIntersecting){
          eintraege.forEach(function(e){ e.a.removeAttribute('aria-current'); });
          t.a.setAttribute('aria-current', 'true');
        }
      });
    }, { rootMargin: '-20% 0px -70% 0px' });
    eintraege.forEach(function(e){ io.observe(e.h); });
  }

  function init(){ initReveal(); initStickyAtc(); initRail(); initSuchfeld(); initKontoMenue(); schienenAusrichten(true); rechtsverzeichnis(); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  // Re-run reveal after Horizon section re-renders (cart, etc.)
  document.addEventListener('shopify:section:load', initReveal);
  // Der Variantenwaehler tauscht sein Markup bei jeder Auswahl aus, deshalb
  // nach dem Wechsel erneut ausrichten statt einmal beim Laden zu binden.
  document.addEventListener('change', function(){ schienenAusrichten(false); });
  document.addEventListener('variant:change', function(){ schienenAusrichten(false); });
  document.addEventListener('shopify:section:load', function(){ schienenAusrichten(true); });
})();
